import { useEffect } from 'react'
import { useUser } from '@fs/zion-user'
import useEP from './useEP'
import { getTreeData } from '../services/services'

const useTreeData = (d) => {
  const personId = d?.personId || d?.person?.personId || d?.personInfo?.personId || null
  const { signedIn } = useUser()
  const [state, dispatch, fn] = useEP(getTreeData)

  useEffect(() => {
    if (personId && signedIn) {
      dispatch({ type: 'load' })
    }
  }, [dispatch, personId, signedIn])

  useEffect(() => {
    if (state.load && personId && signedIn) {
      getTreeData({ personId }).then((res) => {
        dispatch({ type: 'complete', res })
      })
    }
  }, [dispatch, personId, signedIn, state.load])

  return [state, dispatch, fn]
}
export default useTreeData
